import { useDispatch, useSelector } from "react-redux";
import { getStores } from "../redux/selectors";
import { switchStoreId } from "../redux/user/slice";

export const ServingAreaSelector = () => {
  const stores = useSelector(getStores);
  const dispatch = useDispatch();

  return (
    <div className="flex flex-col items-center justify-center p-4">
      <h2 className="text-2xl font-bold mb-4 text-center">
        <span className="hidden md:inline">Please</span>{" "}
        <span className="capitalize"> choose your serving area</span>
      </h2>
      <div className="flex sm:flex-row items-center">
        {stores.map((store) => (
          <button
            key={store._id}
            className="px-6 py-2 mb-3 mx-4 rounded bg-[#4c961b] text-white hover:bg-mainRed transition"
            onClick={() => dispatch(switchStoreId(store._id))}
          >
            {store.title}
          </button>
        ))}
      </div>
    </div>
  );
};
